<section class="mc" aria-labelledby="mc-title">
  <header class="mc__head">
    <div class="mc__intro">
      <h2 class="bk-section-title" id="mc-title">Messages</h2>
      @if (loaded) {
        <p class="mc__sub">
          {{ summary }} Each message goes to every recipient at each of its scheduled times.
        </p>
      }
    </div>

    <!-- With no messages, the empty state below carries the one Add message button. -->
    @if (!loaded || messages.length) {
      <button type="button" class="bk-btn bk-btn--ghost" [disabled]="!loaded" (click)="createMessage = true">
        <span class="bk-sym" aria-hidden="true">add</span>
        Add message
      </button>
    }
  </header>

  <!-- Persistent, so screen readers hear the change -->
  <span class="bk-sr-only" role="status">{{ loaded ? "" : "Loading messages" }}</span>

  @if (!loaded) {
    <div class="mc__grid" aria-hidden="true">
      @for (card of [1, 2]; track card) {
        <div class="bk-panel mc__skel">
          <span class="bk-skel" style="width: 45%; height: 18px"></span>
          <span class="bk-skel" style="width: 30%; height: 12px"></span>
          <span class="bk-skel mc__skel-bubble"></span>
          <span class="bk-skel" style="width: 60%; height: 12px"></span>
        </div>
      }
    </div>
  } @else if (messages.length) {
    <div class="mc__grid">
      @for (message of messages; track message.id; let i = $index) {
        <app-message-content-card
          [message]="message"
          [meta]="meta[message.id]"
          [campaignData]="campaign"
          [index]="i"
          [style.--i]="i"
        ></app-message-content-card>
      }
    </div>
  } @else {
    <div class="bk-panel mc__empty">
      <p class="mc__empty-title">No messages yet.</p>
      <p class="mc__empty-body">
        Add a message, then give it one or more schedules. Each schedule sends it
        to the whole audience.
      </p>
      <button type="button" class="bk-btn bk-btn--primary" (click)="createMessage = true">
        <span class="bk-sym" aria-hidden="true">add</span>
        Add message
      </button>
    </div>
  }

  <!-- create message form -->
  @if (createMessage) {
    <app-create-message
      [openModal]="createMessage"
      (onClose)="createMessage = false"
      [campaignData]="campaign"
    ></app-create-message>
  }
</section>
